import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoFatturaPassivaStep2Component } from './conservazione-carica-documento-fattura-passiva-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-fattura-passiva-step2', {
            url: '/conservazione-carica-fattura-passiva',
            ncyBreadcrumb: {
                label: 'Carica Fattura Passiva',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-fattura-passiva-step2 flex="100"></conservazione-carica-documento-fattura-passiva-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoFatturaPassivaStep2Module: string = ng
    .module('conservazione-carica-documento-fattura-passiva-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoFatturaPassivaStep2', ConservazioneCaricaDocumentoFatturaPassivaStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-fattura-passiva-step2/conservazione-carica-documento-fattura-passiva-step2.module.ts